export default {
  usage: 'Verwendung',
  parameters: 'Parameter',
  body: 'Inhalt',
  bodyHint: 'Lassen Sie den Inhalt leer, um den Standardinhalt zu verwenden. Ein geänderter Inhalt gilt für jeden Bericht.',
  copyDefaultBody: 'Standardinhalt kopieren',
  resetBody: 'Standardinhalt verwenden',
};
